import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from "chart.js";
import { connect } from "react-redux";
import { Loading } from "../../../redux/action";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  erOrganic?: any;
}



const BrandErVerticalChart: React.FC<Props> = (props: Props) => {
  const monthNamesShort = [
    "Jan", "Feb", "Mar", "Apr", "May", "June",
    "July", "Aug", "Sept", "Oct", "Nov", "Dec"
  ];

  const typeColorMap: Record<string, string> = {
    "Nano": "#D379F0",
    "Micro": "#FEB918",
    "Micro Plus": "#288CFF",
    "Macro": "#34E39A",
    "Macro Plus": "#978D58",
    "Mega": "#FF644F",
    "Mega Plus": "#18587A"
  };

  const formattedData: Record<string, Record<string, number>> = {};
  props.erOrganic?.forEach((item: any) => {
    const [year, month] = item?.MONTH.split('-');
    const monthName = monthNamesShort[parseInt(month, 10) - 1];
    const label = `${monthName} ${year}`; // e.g., "Mar 2025"
    const cleanType = item?.influencer_type.replace(/\s+/g, ''); 

    if (!formattedData[label]) {
      formattedData[label] = {};
    }

    if (!formattedData[label][cleanType]) {
      formattedData[label][cleanType] = 0;
    }

    formattedData[label][cleanType] += item.no_of_influencers;
  });

  const allMonthYears = Object.keys(formattedData).sort((a, b) =>
    new Date(a).getTime() - new Date(b).getTime()
  );

  const allLevels = Array.from(
    new Set(
      allMonthYears.flatMap(month => Object.keys(formattedData[month] || {}))
    )
  );

  const colorPalette = [
    "#D379F0", "#FEB918", "#288CFF", "#34E39A", "#978D58", "#FF644F", "#18587A"
  ];

  const datasets = allLevels.map((level, index) => ({
    label: level,
    data: allMonthYears.map(month => formattedData[month]?.[level] || 0),
    backgroundColor: typeColorMap[level.replace(/([a-z])([A-Z])/g, '$1 $2')] || "#CCCCCC",
    borderRadius: 5,
    barThickness: 25,
  }));

  // Step 6: Final chart config
  const chartConfig = {
    labels: allMonthYears,
    datasets,
  };

  const maxEngagement = Math.max(
    ...chartConfig.datasets.flatMap(dataset => dataset.data)
  );

  const yAxisMax = Math.ceil(maxEngagement) + 2;

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    height: 300,
    indexAxis: "x" as const,
    plugins: {
      legend: {
        display: false,
      },
    },
    plotOptions: {
      column: {
        groupPadding: 0.1,
        pointPadding: 0.1,
        borderWidth: 0,
        borderRadius: 8,
      }
    },
    scales: {
      x: {
        stacked: false,
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        max: yAxisMax,
      },
    },
    layout: {
      padding: {
        top: 25,
      },
    },
  };

  return (
    <div style={{ minHeight: '300px', width: '100%' }}>
      <Bar data={chartConfig} options={chartOptions} />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(BrandErVerticalChart);

export { connectToRedux as BrandErVerticalChart };
